export interface RangeLimits {
  max: number;
  min: number;
}

export function getRangeLimitsFromScaling(
  scaling: {
    verticalAxisMax: number;
    verticalAxisMin: number;
    horizontalAxisMax: number;
    horizontalAxisMin: number;
  },
  margin: number,
  vertical: boolean
): RangeLimits {
  return {
    max: (vertical ? scaling.verticalAxisMax : scaling.horizontalAxisMax) - margin,
    min: (vertical ? scaling.verticalAxisMin : scaling.horizontalAxisMin) + margin
  };
}

export function getZeroRangeLimits(): RangeLimits {
  return { max: 0, min: 0 };
}

export function getMinimalRangeLimits(): RangeLimits {
  return { max: Number.MIN_SAFE_INTEGER, min: Number.MAX_SAFE_INTEGER };
}

export function checkRangeLimits(range: RangeLimits, value: number): void {
  range.max = Math.max(range.max, value);
  range.min = Math.min(range.min, value);
}
